import styled from 'styled-components';
import media from 'styled-media-query';
import { MDBContainer } from 'mdbreact';

import { Card } from 'components/Cards/ContentFormCard/styles';
import { Text } from 'components/DescriptionText/styles';
import { Divider as DefaultDivider } from 'components/FormGroup/Divider/styles';

import colors from 'themes/Main';

const { gray05, danger } = colors;

export const Container = styled(MDBContainer)`
  margin: 0 auto;
  max-width: calc(100% - 224px) !important;

  ${media.lessThan('medium')`
    max-width: 100% !important;
  `}
`;

export const Introduction = styled.div`
  margin-top: 50px;
`;

export const FeaturedText = styled(Text)`
  text-transform: uppercase;
`;

export const Divider = styled(DefaultDivider)`
  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -4px;
    width: 100%;
    height: 1px;
    background-color: ${gray05};
  }
`;

export const Form = styled.form``;

export const FlexRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Buttons = styled.div`
  margin: 32px 0;

  button:nth-child(2) {
    margin-left: 16px;
  }
`;

export const Employee = styled(Card)`
  &.hasError {
    border: 1px solid ${danger};
  }

  > * {
    cursor: default;
  }

  span {
    display: inline-block;
  }

  > div {
    margin-top: 4px;
  }
`;

export const EmployeeInfos = styled.div`
  flex: 1;
`;

export const ActionButtons = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  button {
    background: transparent;
    border: 0;
    padding: 8px;

    + button {
      margin-top: 8px;
    }

    &:hover {
      opacity: .6;
    }
  }
`;

export const Errors = styled.div`
  margin: -8px 0 20px;
`;
